import { showError } from "../components/ErrorPopup";
import React, { useState, useEffect } from "react";
import { CheckCircleIcon, InformationCircleIcon } from "@heroicons/react/solid";
// import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../utils/apiClient";
import UsersList from "../components/UsersList";
import { TrashIcon } from "@heroicons/react/solid";
import { XCircleIcon } from "@heroicons/react/solid";
// import { SlideshowLightbox } from "lightbox.js-react";
import Resizer from "react-image-file-resizer";
import { PDFDocument } from "pdf-lib";
import { FilePreviewModal } from "../components/FilePreviewModal";
import ModernDatePicker from "../components/ModernDatePicker";
import DraftsPopup from "../components/DraftsPopup";
import { io } from "socket.io-client";
const socket = io.connect(`${process.env.REACT_APP_API_BASE_URL}`); 

const getDateFinEntenteMax = (dateDebutEntente) => {
  if (!dateDebutEntente) return "";

  const [annee, mois] = dateDebutEntente.split("-").map(Number);
  const anneeFin = mois >= 8 ? annee + 1 : annee;

  return `${anneeFin}-09-01`;
};

const getDateDebutEntenteMax = () => {
  const dateMax = new Date();
  const jourInitial = dateMax.getDate();
  dateMax.setDate(1);
  dateMax.setMonth(dateMax.getMonth() + 4);
  const dernierJourDuMois = new Date(
    dateMax.getFullYear(),
    dateMax.getMonth() + 1,
    0,
  ).getDate();
  dateMax.setDate(Math.min(jourInitial, dernierJourDuMois));

  const annee = dateMax.getFullYear();
  const mois = String(dateMax.getMonth() + 1).padStart(2, "0");
  const jour = String(dateMax.getDate()).padStart(2, "0");

  return `${annee}-${mois}-${jour}`;
};

const getHeureFinMax = (heureDebutTravail) => {
  if (!heureDebutTravail) return "";

  const [heures, minutes] = heureDebutTravail.split(":").map(Number);
  const totalMinutes = heures * 60 + minutes + 8 * 60;
  const heureFin = Math.floor(totalMinutes / 60);
  const minuteFin = totalMinutes % 60;

  return `${String(heureFin).padStart(2, "0")}:${String(minuteFin).padStart(2, "0")}`;
};

const formatEntenteDraftDate = (draft) => {
  if (!draft.dateSoumission) return "";

  const date = new Date(draft.dateSoumission);
  if (Number.isNaN(date.getTime())) return "";

  return new Intl.DateTimeFormat("fr-CA", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(date);
};

const getHeuresFinDisponibles = (heureDebutTravail) => {
  if (!heureDebutTravail) return [];

  const [heures, minutes] = heureDebutTravail.split(":").map(Number);
  const debutEnMinutes = heures * 60 + minutes;
  const premiereFin = debutEnMinutes + 3 * 60 + 30;
  const derniereFin = Math.min(debutEnMinutes + 8 * 60, 17 * 60);
  const options = [];

  for (let total = premiereFin; total <= derniereFin; total += 30) {
    const heure = Math.floor(total / 60);
    const minute = total % 60;
    options.push(
      `${String(heure).padStart(2, "0")}:${String(minute).padStart(2, "0")}`,
    );
  }

  return options;
};

const getDureeEnMinutes = (heureDebutTravail, heureFinTravail) => {
  const [heureDebut, minuteDebut] = heureDebutTravail.split(":").map(Number);
  const [heureFin, minuteFin] = heureFinTravail.split(":").map(Number);

  return heureFin * 60 + minuteFin - (heureDebut * 60 + minuteDebut);
};

const EntenteTravailHybrid = ({ user, enabled }) => {
  const [isSubmitted, setIsSubmitted] = useState(false); // State to control popup
  const [message, setMessage] = useState("");
  const [couleur, setcouleur] = useState("");
  const [errors, setErrors] = useState({});

  const navigate = useNavigate(); // Initialize navigate hook
  const [isReadOnly, setIsReadOnly] = useState(false);
  // const [showTable, setShowTable] = useState(false);


  const [commentaire, setCommentaire] = useState("");

  const [uploadedFile, setUploadedFile] = useState(null);
  const [filePreviewUrl, setFilePreviewUrl] = useState(null);
  const [fileUploadError, setFileUploadError] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [showErgonomieHelp, setShowErgonomieHelp] = useState(false);

  const [selectedForm, setSelectedForm] = useState(null);
  const [formId, setFormId] = useState(null);
  const [drafts, setDrafts] = useState([]);
  const [showDraftPopup, setShowDraftPopup] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const numeroFormulaire = params.get("numeroFormulaire");
  const page = params.get("page");
  // const [isLoading, setIsLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(!!page);
  const [showAccessDenied, setShowAccessDenied] = useState(false);

  const [selectedFile, setSelectedFile] = useState(null);
  const fileUrl = selectedFile ? URL.createObjectURL(selectedFile) : "";

  useEffect(() => {
    if (!enabled || !user?.id || numeroFormulaire || page) return;

    const controller = new AbortController();

    const fetchDrafts = async () => {
      try {
        const response = await apiFetch(
          `${process.env.REACT_APP_API_BASE_URL}/entente-travail-hybrid/brouillons`,
          { signal: controller.signal },
        );
        const data = await response.json();

        if (!response.ok) throw new Error(data.error || data.message);
        if (controller.signal.aborted) return;

        setDrafts(data);
        setShowDraftPopup(data.length > 0);
      } catch (error) {
        if (!controller.signal.aborted) console.error(error);
      }
    };

    fetchDrafts();
    return () => controller.abort();
  }, [enabled, user?.id, numeroFormulaire, page]);

  const handleDeleteDraft = async (id) => {
    try {
      const response = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/modify-etatdemande/${id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            etatDemande: "Supprimé",
            nomFormulaire: "Entente de travail en mode hybrid",
            userId: user.id,
            nom: user.displayName,
            email: user.mail,
            commentaire: "",
          }),
        },
      );
      const data = await response.json();

      if (!response.ok) throw new Error(data.error || data.message);

      setDrafts((current) => current.filter((draft) => draft._id !== id));
    } catch (error) {
      console.error(error);
      showError(error);
    }
  };

  // ✅ useEffect pour récupérer le formulaire depuis sessionStorage et l’API
  useEffect(() => {
    let isMounted = true;

    const fetchForm = async () => {
      try {
        // ✅ guard clause (BEST PRACTICE)
        if (!numeroFormulaire || !user.id || !page) {
          console.warn("Missing form identifiers");
          navigate("/EntenteTravailHybrid");
          return;
        }
        setIsLoading(true);
        const response = await apiFetch(
          `${process.env.REACT_APP_API_BASE_URL}/selectedFormETH?numeroFormulaire=${numeroFormulaire}&page=${page}`,
        );

        if (!response.ok) {
          if (response.status === 403) {
            throw new Error("NOT_AUTHORIZED");
          }
          if (response.status === 400) {
            throw new Error("BAD_REQUEST");
          }
          throw new Error("FAILED_FETCH");
        }

        const data = await response.json();

        if (!isMounted) return;

        setSelectedForm(data);
        setFormId(data._id);
      } catch (error) {
        if (error.message === "NOT_AUTHORIZED") {
          setShowAccessDenied(true);
        } else {
          console.error("Error fetching form data:", error);
        }
      } finally {
        if (!isMounted) return;

        setTimeout(() => {
          if (!isMounted) return;
          setIsLoading(false);
        }, 400);
      }
    };

    fetchForm();

    return () => {
      isMounted = false;
    };
  }, [user, numeroFormulaire, page]);

  const base64ToFile = (base64, filename, mimeType) => {
    // Remove the base64 data prefix (if it exists)
    const base64String = base64.split(",")[1]; // Get the part after the comma
    if (!base64String) {
      throw new Error("Invalid base64 string");
    }

    // Decode the base64 string
    const byteCharacters = atob(base64String);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: mimeType });
    const file = new File([blob], filename, { type: mimeType });

    return file;
  };

  const handleFileUpload = async (e) => {
    const MAX_FILE_SIZE_MB = 5;
    const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

    const file = e.target.files[0];
    if (!file) return;

    const ALLOWED_TYPES = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ];

    if (!ALLOWED_TYPES.includes(file.type)) {
      setFileUploadError("Formats acceptés : PDF, JPG, JPEG, PNG.");
      return;
    }

    const resizeImage = (file) =>
      new Promise((resolve) => {
        if (!file.type.includes("image")) return resolve(file);

        Resizer.imageFileResizer(
          file,
          1600,
          1600,
          "WEBP",
          70,
          0,
          (uri) => {
            const resizedFile = new File([uri], file.name, {
              type: "image/webp",
            });
            resolve(resizedFile);
          },
          "blob",
          200,
          200,
        );
      });

    const compressPDF = async (file) => {
      if (file.type !== "application/pdf") return file;

      try {
        const arrayBuffer = await file.arrayBuffer();

        const pdfDoc = await PDFDocument.load(arrayBuffer, {
          ignoreEncryption: false,
        });

        const compressedBytes = await pdfDoc.save();
        return new File([compressedBytes], file.name, {
          type: "application/pdf",
        });
      } catch (error) {
        console.error("Erreur lors du traitement du PDF :", error);

        // PDF protégé ou non lisible → on garde le fichier original
        if (
          error?.message?.toLowerCase().includes("encrypted") ||
          error?.message?.toLowerCase().includes("password") ||
          error?.message?.toLowerCase().includes("decrypt")
        ) {
          setFileUploadError(
            "Ce fichier PDF semble être protégé par mot de passe. Vous pouvez tout de même le joindre, puis indiquer le mot de passe dans le champ prévu à cet effet.",
          );
          return file;
        }

        throw new Error(
          "Le fichier PDF n’a pas pu être traité. Veuillez vérifier le document et réessayer.",
        );
      }
    };

    const processFile = async (file) => {
      if (file.type.includes("image")) {
        return await resizeImage(file);
      } else if (file.type === "application/pdf") {
        return await compressPDF(file);
      }
      return file;
    };

    try {
      const processedFile = await processFile(file);

      if (processedFile.size > MAX_FILE_SIZE) {
        setFileUploadError(
          `Le fichier dépasse la taille maximale permise de ${MAX_FILE_SIZE_MB} Mo.`,
        );
        return;
      }

      setFileUploadError("");
      setUploadedFile(processedFile);
      setFilePreviewUrl(URL.createObjectURL(processedFile));

      setFormData((prev) => ({
        ...prev,
        uploadedFile: {
          filename: processedFile.name,
          contentType: processedFile.type,
          data: "",
        },
      }));

      setErrors("");
    } catch (error) {
      console.error(error);
      setFileUploadError(
        error.message ||
          "Une erreur est survenue lors du téléversement du fichier.",
      );
    }
  };

  const handleFileDelete = () => {
    setUploadedFile(null);
    setFilePreviewUrl(null);
    setShowPopup(false);
    setSelectedFile(null);
    setFileUploadError("");
    setFormData((prevData) => ({
      ...prevData,
      uploadedFile: null,
    }));

    const fileInput = document.getElementById("fileUpload");
    if (fileInput) {
      fileInput.value = "";
    }
  };



  const joursSemaine = [
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Flexible",
  ];

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;

    setFormData((prev) => {
      const joursTravailBureau = checked
        ? [...new Set([...prev.joursTravailBureau, value])]
        : prev.joursTravailBureau.filter((jour) => jour !== value);

      return {
        ...prev,
        joursTravailBureau,
      };
    });
  };

  const frequences = [
    "À la semaine",
    "Aux deux semaines",
    "Aux trois semaines",
    "Au mois",
  ];

  const handleCheckboxChangeFrequence = (e) => {
    setFormData((prev) => ({
      ...prev,
      frequenceTravail: e.target.value,
    }));
  };
  const handleUserSelect = (user, fieldName) => {
    handleChange({
      target: {
        name: fieldName,
        value: {
          nom: user.displayName,
          email: user.mail,
          userId: user.id,
          matricule: user.employeeId,
          etatDemande: "",
        },
      },
    });
  };

  // Function to generate numeroFormulaire
  const generateNumeroFormulaire = () => {
    const date = new Date();
    const yy = date.getFullYear().toString().slice(-2); // Get last two digits of the year
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Month (0-padded)
    const dd = String(date.getDate()).padStart(2, "0"); // Day (0-padded)
    const randomNumber = Math.floor(1000 + Math.random() * 9000); // Random 4-digit number

    return `CSV-${yy}${mm}${dd}${randomNumber}-ETH`;
  };
  const questions = [
    {
      name: "mobilierEquipementAdequat",
      label:
        "Les meubles et l’équipement du poste de travail répondent aux besoins du télétravailleur. Il s’agit entre autres d’un bureau, d’une chaise, d’un casque d’écoute et d’autres périphériques.",
    },
    {
      name: "formationErgonomieCompletee",
      label:
        "J’ai réussi la formation « Ergonomie et poste de travail » sur eBase.",
      info:
        "Cette formation doit être complétée lors de l’embauche et de nouveau au début de chaque année scolaire.",
      hasHelp: true,
    },
    {
      name: "barreAlimentationParasurtenseur",
      label:
        "L'ordinateur est pourvu d’une barre d’alimentation dotée d’un parasurtenseur.",
    },
    {
      name: "eclairageAdequat",
      label: "L’espace de télétravail comporte un éclairage adéquat.",
    },
    {
      name: "espaceLibreDebrisObstacles",
      label: "L’espace de télétravail est libre de débris et d’obstacles.",
    },
    {
      name: "plancherSecuritaire",
      label:
        "La surface de plancher est sécuritaire et dégagée de sorte à ne présenter aucun risque de trébuchement ou de glissade.",
    },
    {
      name: "filsDissimules",
      label:
        "Les fils électriques et téléphoniques ont été dissimulés pour éviter tout risque de trébuchement.",
    },
    {
      name: "appliquesPlafonniersSolidementVisses",
      label: "Les appliques murales et les plafonniers sont vissés solidement.",
    },

    {
      name: "barresAlimentationBrancheesDirectement",
      label:
        "Les barres d’alimentation sont branchées directement dans les prises de courant.",
    },

    {
      name: "classeursEtEtageresSecuritaires",
      label:
        "a) Les classeurs sont de niveau et ont été remplis adéquatement. b) Les étagères, bibliothèques et armoiressont solides et fixées adéquatement (p. ex.,au mur, si nécessaire).",
    },
    {
      name: "passagesSortiesDegages",
      label:
        "Il n’y a pas d’objets qui encombrent le passage ou les sorties dans l’espace de télétravail.",
    },

    {
      name: "sourcesChaleurDegagee",
      label:
        "Rien n’obstrue les sources de chaleur afin d’éviter les incendies.",
    },
    {
      name: "planUrgenceEvacuation",
      label:
        "Des procédures d’urgence et un plan d’évacuation ont été établis.",
    },
    {
      name: "detecteurFumeeFonctionnel",
      label:
        "Un détecteur de fumée fonctionnel est installé près de l’espace de télétravail.",
    },
    {
      name: "ventilationTemperatureBruit",
      label:
        "Il est possible de régler la ventilation, la température et de contrôler le niveau de bruit.",
    },
    {
      name: "troussePremiersSoinsDisponible",
      label: "Des fournitures de premiers soins adéquates sont disponibles.",
    },
  ];

  const getQuestionsValues = (form) =>
    Object.fromEntries(questions.map((q) => [q.name, form?.[q.name] || ""]));

  const initialFormData = {
    numeroFormulaire: generateNumeroFormulaire(),
    dateSoumission: new Date().toISOString().split("T")[0],
    managerInfo: selectedForm?.managerInfo || {
      nom: "",
      email: "",
      userId: "",
      matricule: "",
      etatDemande: "",
    },
    directionSecteurSurintendance:
      selectedForm?.directionSecteurSurintendance || {
        nom: "",
        email: "",
        userId: "",
        matricule: "",
      },
    dateDebutEntente: selectedForm?.dateDebutEntente || "",
    dateFinEntente: selectedForm?.dateFinEntente || "",
    heureDebutTravail: selectedForm?.heureDebutTravail || "",
    heureFinTravail: selectedForm?.heureFinTravail || "",
    telephoneDomicile: selectedForm?.telephoneDomicile || "",
    telephoneCellulaire: selectedForm?.telephoneCellulaire || "",
    adresseBureauDomicile: selectedForm?.adresseBureauDomicile || "",
    joursTravailBureau: selectedForm?.joursTravailBureau || [],
    frequenceTravail: selectedForm?.frequenceTravail || "",
    resideOntario: selectedForm?.resideOntario || "",
    acceptationModalites: selectedForm?.acceptationModalites || "non",
    situationApplicable: selectedForm?.situationApplicable || "",
    descriptionLieuTravailDomicile:
      selectedForm?.descriptionLieuTravailDomicile || "",
    uploadedFile: null,
    ...getQuestionsValues(selectedForm),
    risquesEtCommentaires: selectedForm?.risquesEtCommentaires || "",
    informationsfourniesExactes:
      selectedForm?.informationsfourniesExactes || "non",

    etatDemande: selectedForm?.etatDemande || "",
    traitant: selectedForm?.traitant || [],
  };
  // console.log("selected Form: ", selectedForm);
  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (user && !selectedForm) {
      setFormData((prevData) => ({
        ...prevData,
        userId: user.id,
        nom: user.displayName,
        matricule: user.employeeId,
        poste: user.jobTitle,
        courriel: user.mail,
      }));
    }

    if (selectedForm) {
      if (
        (selectedForm.etatDemande !== "Brouillon" &&
          selectedForm.etatDemande !== "Rejeté" &&
          page !== "Mes taches") ||
        page === "Mes taches"
      ) {
        setIsReadOnly(true);
      }

      setFormData((prevData) => ({
        ...prevData,
        userId: selectedForm.userId,
        nom: selectedForm.nom,
        matricule: selectedForm.matricule,
        poste: selectedForm.poste,
        courriel: selectedForm.courriel,
        numeroFormulaire: selectedForm.numeroFormulaire,
        dateSoumission:
          selectedForm.etatDemande === "Brouillon"
            ? new Date().toISOString().split("T")[0]
            : selectedForm.dateSoumission || prevData.dateSoumission,
        managerInfo: selectedForm?.managerInfo || {
          nom: "",
          email: "",
          userId: "",
          matricule: "",
          etatDamande: "",
        },
        directionSecteurSurintendance:
          selectedForm?.directionSecteurSurintendance || {
            nom: "",
            email: "",
            userId: "",
            matricule: "",
          },
        dateDebutEntente: selectedForm?.dateDebutEntente || "",
        dateFinEntente: selectedForm?.dateFinEntente || "",
        heureDebutTravail: selectedForm?.heureDebutTravail || "",
        heureFinTravail: selectedForm?.heureFinTravail || "",
        telephoneDomicile: selectedForm?.telephoneDomicile || "",
        telephoneCellulaire: selectedForm?.telephoneCellulaire || "",
        adresseBureauDomicile: selectedForm?.adresseBureauDomicile || "",
        joursTravailBureau: selectedForm?.joursTravailBureau || [],
        frequenceTravail: selectedForm?.frequenceTravail || "",
        resideOntario: selectedForm?.resideOntario || "",
        acceptationModalites: selectedForm?.acceptationModalites || "non",
        situationApplicable: selectedForm?.situationApplicable || "",
        descriptionLieuTravailDomicile:
          selectedForm?.descriptionLieuTravailDomicile || "",
        ...getQuestionsValues(selectedForm),
        risquesEtCommentaires: selectedForm?.risquesEtCommentaires || "",
        informationsfourniesExactes:
          selectedForm?.informationsfourniesExactes || "non",

        etatDemande: selectedForm?.etatDemande || "",

        traitant: selectedForm?.traitant || [],
      }));
    }
    if (
      selectedForm?.uploadedFile?.data &&
      selectedForm?.uploadedFile?.contentType &&
      selectedForm?.uploadedFile?.filename
    ) {
      const base64String = `data:${selectedForm.uploadedFile.contentType};base64,${selectedForm.uploadedFile.data}`;
      const file = base64ToFile(
        base64String,
        selectedForm.uploadedFile.filename,
        selectedForm.uploadedFile.contentType,
      );

      setUploadedFile(file);
      setFilePreviewUrl(URL.createObjectURL(file));
    }
  }, [user, selectedForm]); // Add selectedForm to the dependency array

  const handleFormAction = async (e, actionType, updatedTraitant = null) => {
    e.preventDefault();

    const currentDate = new Date();

    const updatedFormData = {
      ...formData,
      etatDemande: actionType,
      dateSoumission: currentDate,
      traitant: updatedTraitant ?? formData.traitant ?? [],
    };
    console.log("formId:", formId);
    const method = formId ? "PUT" : "POST";
    const formType = "EntenteTravailHybrid";
    const url = formId
      ? `${process.env.REACT_APP_API_BASE_URL}/formFile/${formId}?form=${formType}` // Use the selectedForm ID to update
      : `${process.env.REACT_APP_API_BASE_URL}/formFile?form=${formType}`; // Use POST for creating a new form

    const formDataToSend = new FormData();

    // Append form data fields to FormData (use JSON.stringify for nested objects if needed)
    formDataToSend.append("updatedFormData", JSON.stringify(updatedFormData));
    if (uploadedFile) {
      const blob = new Blob([uploadedFile], { type: uploadedFile.type });
      formDataToSend.append("file", blob, uploadedFile.name);
      // console.log(uploadedFile);
    }

    try {
      const response = await apiFetch(url, {
        method: method,
        body: formDataToSend,
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || result.message);
      }
      if(updatedFormData.etatDemande !== "Brouillon"){
          if (socket) {
          socket.emit("requestUpdated");
        }
        }

      setIsSubmitted(true);
      await new Promise((resolve) => {
        setTimeout(() => {
          setIsSubmitted(false);
          resolve();
        }, 3000);
      });

      setErrors({});

      if (page === "Mes taches") {
        if (window.opener && !window.opener.closed) {
          window.close();
        } else {
          navigate("/taches");
        }
      } else {
        if (actionType !== "Brouillon") {
          navigate("/demande", { state: { selectedForm: null } });
        }
      }
    } catch (error) {
      console.error(error);
      showError(error); // ou setError(error.message)
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "situationApplicable" && value === "non") {
      setUploadedFile(null);
      setFilePreviewUrl(null);
      setSelectedFile(null);
      setShowPopup(false);
      setFileUploadError("");

      const fileInput = document.getElementById("fileUpload");
      if (fileInput) fileInput.value = "";
    }

    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: value,
      };

      if (name === "situationApplicable" && value === "non") {
        updatedData.descriptionLieuTravailDomicile = "";
        updatedData.uploadedFile = null;
      }

      if (name === "dateDebutEntente") {
        const dateFinMax = getDateFinEntenteMax(value);

        if (prevData.dateFinEntente && prevData.dateFinEntente > dateFinMax) {
          updatedData.dateFinEntente = "";
        }
      }

      if (name === "heureDebutTravail") {
        const heureFinMax = getHeureFinMax(value);

        if (
          prevData.heureFinTravail &&
          (prevData.heureFinTravail <= value ||
            prevData.heureFinTravail > heureFinMax ||
            getDureeEnMinutes(value, prevData.heureFinTravail) <= 3 * 60)
        ) {
          updatedData.heureFinTravail = "";
        }
      }

      return updatedData;
    });

    setErrors("");
  };

  // petite fonction réutilisable pour ajouter un traitant sans doublon
  const addTraitantEntry = (etat) => {
    const currentUser = {
      userId: user?.id || "",
      nom: user?.displayName || "",
      email: user?.mail || "",
      matricule: user?.employeeId || "",
      etatDemande: etat,
      commentaire: commentaire || "",
      dateHeure: new Date(),
    };

    const existingTraitants = formData.traitant || [];

    return [...existingTraitants, currentUser];
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const updatedTraitant = [
      ...(formData.traitant || []),
      {
        userId: formData.managerInfo.userId,
        nom: formData.managerInfo.nom,
        email: formData.managerInfo.email,
        matricule: formData.managerInfo.matricule,
        etatDemande: "En traitement",
        commentaire: "",
        dateHeure: new Date(),
      },
    ];
    handleFormAction(e, "En traitement", updatedTraitant);

    setMessage("Succès ! La demande est maintenant en traitement.");
    setcouleur("text-green-600");
  };

  const handleApprouve = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const updatedTraitant = addTraitantEntry("Approuvé");

    handleFormAction(e, "Approuvé", updatedTraitant);
    setMessage("Succès ! Le formulaire a été Approuvé.");
    setcouleur("text-green-600");
    setErrors("");
  };

  const handleRejeter = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const updatedTraitant = addTraitantEntry("Rejeté");

    handleFormAction(e, "Rejeté", updatedTraitant);
    setMessage("Le formulaire a été Rejeté.");
    setcouleur("text-red-700");
    setErrors("");
  };

  const handleSave = (e) => {
    handleFormAction(e, "Brouillon"); // Use "Enregistrer" for save action
    setMessage(
      "Succès ! Le formulaire a été enregistré.\nVeuillez noter que l'enregistrement ne signifie pas que le formulaire a été soumis.",
    );
    setcouleur("text-grey-600");
    setErrors("");
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.numeroFormulaire) newErrors.nom = "Ce champ est requis.";
    if (!formData.dateSoumission) newErrors.nom = "Ce champ est requis.";
    if (!formData.nom) newErrors.nom = "Ce champ est requis.";
    if (!formData.courriel) newErrors.courriel = "Ce champ est requis.";
    if (!formData.poste) newErrors.poste = "Ce champ est requis.";

    if (!formData.managerInfo?.nom || formData.managerInfo.nom.trim() === "") {
      newErrors.managerInfo = "Ce champ est requis.";
    }

   

    if (!formData.directionSecteurSurintendance?.nom || formData.directionSecteurSurintendance.nom.trim() === "") {
      newErrors.directionSecteurSurintendance = "Ce champ est requis.";
    }

    if (!formData.dateDebutEntente) {
      newErrors.dateDebutEntente = "La date est obligatoire.";
    }
    if (!formData.dateFinEntente) {
      newErrors.dateFinEntente = "La date est obligatoire.";
    } else if (formData.dateFinEntente <= formData.dateDebutEntente) {
      newErrors.dateFinEntente =
        "La date de fin doit être ultérieure à la date de début.";
    } else if (
      formData.dateDebutEntente &&
      formData.dateFinEntente >
      getDateFinEntenteMax(formData.dateDebutEntente)
    ) {
      newErrors.dateFinEntente =
        "La date de fin ne peut pas dépasser le 1er septembre autorisé.";
    }

    if (!formData.heureDebutTravail) {
      newErrors.heureDebutTravail = "L'heure de début est obligatoire.";
    }
    if (
      formData.heureDebutTravail &&
      (formData.heureDebutTravail < "06:00" ||
        formData.heureDebutTravail > "09:00")
    ) {
      newErrors.heureDebutTravail =
        "L'heure de début doit être comprise entre 06:00 et 09:00.";
    }

    if (!formData.heureFinTravail) {
      newErrors.heureFinTravail = "L'heure de fin est obligatoire.";
    } else if (
      formData.heureDebutTravail &&
      formData.heureFinTravail <= formData.heureDebutTravail
    ) {
      newErrors.heureFinTravail =
        "L'heure de fin doit être postérieure à l'heure de début.";
    } else if (
      formData.heureDebutTravail &&
      formData.heureFinTravail &&
      getDureeEnMinutes(
        formData.heureDebutTravail,
        formData.heureFinTravail,
      ) <= 3 * 60
    ) {
      newErrors.heureFinTravail =
        "La durée de travail doit être supérieure à 3 heures.";
    } else if (
      formData.heureDebutTravail &&
      formData.heureFinTravail &&
      formData.heureFinTravail > getHeureFinMax(formData.heureDebutTravail)
    ) {
      newErrors.heureFinTravail =
        "L'heure de fin ne peut pas dépasser 8 heures après l'heure de début.";
    }

    if (formData.telephoneCellulaire.trim().length < 10) {
      newErrors.telephoneCellulaire = "Le numéro de téléphone invalide";
    }
    if (
      formData.telephoneDomicile.trim().length >= 1 &&
      formData.telephoneDomicile.trim().length < 10
    ) {
      newErrors.telephoneDomicile =
        "Le numéro de téléphone doit contenir 10 chiffres.";
    }

    if (!formData.adresseBureauDomicile)
      newErrors.adresseBureauDomicile = "Ce champ est requis.";

    if (formData.joursTravailBureau.length === 0) {
      newErrors.joursTravailBureau =
        "Veuillez sélectionner au moins une journée de travail hybride.";
    }

    if (!formData.frequenceTravail)
      newErrors.frequenceTravail =
        "Veuillez sélectionner une fréquence de travail à domicile.";

    if (!formData.resideOntario) {
      newErrors.resideOntario = "Ce champ est requis.";
    } else if (formData.resideOntario === "non") {
      newErrors.resideOntario =
        "Vous n'êtes pas autorisé à soumettre une demande de télétravail hors de l'Ontario. Veuillez communiquer avec votre superviseur.";
    }

    if (formData.acceptationModalites === "non") {
      newErrors.acceptationModalites =
        "Veuillez accepter et signer électroniquement les modalités.";
    }

    if (!formData.situationApplicable) {
      newErrors.situationApplicable = "Ce champ est requis.";
    }

    if (formData.situationApplicable === "oui") {
      if (!formData.descriptionLieuTravailDomicile?.trim()) {
        newErrors.descriptionLieuTravailDomicile = "Ce champ est requis.";
      }

      if (!uploadedFile) {
        newErrors.uploadedFile =
          "Veuillez téléverser une photo de votre espace de travail.";
      }
    }

    questions.forEach((question) => {
      if (!formData[question.name]) {
        newErrors[question.name] = "Ce champ est requis.";
      }
    });

    if (formData.informationsfourniesExactes === "non") {
      newErrors.informationsfourniesExactes =
        "Veuillez confirmer que les informations fournies sont exactes et complètes.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const renderError = (field) => {
    return errors[field] ? (
      <p className="flex items-center gap-1.5 text-sm text-red-500 mt-1">
        <span className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-red-100 text-red-500 text-[10px] font-bold flex-shrink-0">
          !
        </span>
        {errors[field]}
      </p>
    ) : null;
  };

  // HandleChange générique
  const handleChangeCheckBox = (e) => {
    const { name, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: checked ? "oui" : "non",
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handlePhoneNumberChange = (e) => {
    let value = e.target.value;

    // Remove any non-numeric characters (allow only digits)
    value = value.replace(/[^0-9]/g, "");

    // Limit the phone number to 10 digits
    if (value.length > 10) {
      value = value.slice(0, 10);
    }

    // Update the state with the phone number
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: value,
    }));

    setErrors("");
  };

  const formatPhoneNumber = (phone) => {
    if (!phone) return "";

    if (phone.length <= 3) {
      return phone;
    }

    if (phone.length <= 6) {
      return `${phone.slice(0, 3)} ${phone.slice(3)}`;
    }

    return `${phone.slice(0, 3)} ${phone.slice(3, 6)} ${phone.slice(6)}`;
  };

  const RadioQuestion = ({
    number,
    name,
    label,
    value,
    onChange,
    renderError,
    hasHelp,
    info,
  }) => {
    return (
      <div className="rounded-lg border border-slate-200 bg-white px-6 py-5 transition-colors hover:border-slate-300">
        <div className="grid grid-cols-[56px_1fr_190px] items-center gap-6">
          {/* Numéro */}
          <div className="flex items-center justify-center">
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-sm font-semibold text-slate-600">
              {number}
            </div>
          </div>

          {/* Question */}
          <div className="min-w-0">
            <label
              htmlFor={`${name}-oui`}
              className="block text-sm font-medium leading-6 text-slate-800"
            >
              {label}
              <span className="ml-0.5 text-base text-red-700">*</span>
            </label>

            {(info || hasHelp) && (
              <div className="mt-3 flex items-start gap-2.5 rounded-lg border-l-4 border-sky-500 bg-sky-50 px-3 py-2.5">
                <InformationCircleIcon className="mt-0.5 h-5 w-5 flex-none text-sky-600" />
                <div className="min-w-0">
                  {info && (
                    <p className="text-xs leading-5 text-slate-700">
                      <span className="font-semibold text-slate-800">À noter : </span>
                      {info}
                    </p>
                  )}
                  {hasHelp && (
                    <button
                      type="button"
                      onClick={() => setShowErgonomieHelp(true)}
                      className="mt-1 text-xs font-semibold text-sky-700 underline decoration-sky-300 underline-offset-2 transition-colors hover:text-sky-900 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                      aria-haspopup="dialog"
                    >
                      Voir les instructions pour accéder à la formation
                    </button>
                  )}
                </div>
              </div>
            )}
            {renderError(name)}
          </div>

          {/* Réponses */}
          <div className="flex justify-end gap-3">
            {[
              { value: "oui", label: "Oui" },
              { value: "non", label: "Non" },
            ].map((option) => {
              const selected = value === option.value;

              return (
                <label
                  key={option.value}
                  className={`
                  min-w-[82px]
                  rounded-md
                  border
                  px-4
                  py-2
                  text-center
                  text-sm
                  font-medium
                  cursor-pointer
                  transition-all

                  ${
                    selected
                      ? "border-blue-600 bg-blue-600 text-white"
                      : "border-slate-300 bg-white text-slate-700 hover:bg-slate-50"
                  }
                `}
                >
                  <input
                    id={`${name}-${option.value}`}
                    type="radio"
                    name={name}
                    value={option.value}
                    checked={selected}
                    onChange={onChange}
                    className="hidden"
                    disabled={isReadOnly}
                  />

                  {option.label}
                </label>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  if (
    (!enabled && !selectedForm && page !== "Mes taches") ||
    (!enabled &&
      selectedForm &&
      selectedForm.etatDemande === "Brouillon" &&
      page !== "Mes taches")
  ) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6 text-center">
        <XCircleIcon className="h-16 w-16 text-red-500 mb-4 animate-pulse" />
        <h3 className="text-2xl font-bold text-red-600 mb-2">
          Formulaire d'entente de travail en mode hybride fermé
        </h3>
        <p className="text-gray-700 max-w-md">
          Le formulaire est désormais fermé.
        </p>
      </div>
    );
  }
  return (
    <div className="relative min-h-screen p-8 bg-gray-100 rounded-lg shadow-lg">
      {showDraftPopup && (
        <DraftsPopup
          drafts={drafts}
          formTitle="Entente de travail en mode hybride"
          formatDate={formatEntenteDraftDate}
          onOpen={(draft) => {
            setIsLoading(true);
            setShowDraftPopup(false);
            navigate(
              `/EntenteTravailHybrid?numeroFormulaire=${encodeURIComponent(draft.numeroFormulaire)}&page=Mes%20demandes`,
            );
          }}
          onDelete={handleDeleteDraft}
          onClose={() => setShowDraftPopup(false)}
        />
      )}
      <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
        <div className="w-[45%]"></div>
        <div className="w-1/2  sm:ml-auto">
          <label
            htmlFor="numeroFormulaire"
            className="block text-sm font-medium text-blue-900"
          >
            Numéro de formulaire:
          </label>
          <input
            type="text"
            id="numeroFormulaire"
            name="numeroFormulaire"
            value={formData.numeroFormulaire}
            onChange={handleChange}
            required
            disabled
            className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
          />
        </div>
      </div>

      <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
        <div className="w-[45%]"></div>
        <div className="w-1/2  sm:ml-auto">
          <label
            htmlFor="dateSoumission"
            className="block text-sm font-medium text-blue-900"
          >
            Date :
          </label>
          <input
            type="date"
            id="dateSoumission"
            name="dateSoumission"
            value={formData.dateSoumission?.split("T")[0] ?? ""}
            onChange={handleChange}
            required
            disabled
            className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
          />
        </div>
      </div>

      {/* <div className="bg-white border border-gray-200 rounded-2xl p-6 mb-8 shadow-sm">

          <p className="text-gray-700 leading-relaxed mb-3">
            Identifier les quantités à commander
          </p>

          <p className="text-gray-700 leading-relaxed">
           S'il y a des articles à commander qui ne figurent pas sur la liste, les inscrire dans la section «Autre»
          </p>

        </div> */}
      <div className="w-full flex justify-center mt-6 mb-20">
        <div className="bg-blue-50 border-l-4 border-blue-500 text-blue-800 p-4 rounded-md shadow-md w-fit">
          <p className="text-md font-bold flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 17v-2a4 4 0 014-4h6m-6 0V9m0 0H9m3 0h3"
              />
            </svg>
            Formulaire d'entente de travail en mode hybride
          </p>
        </div>
      </div>
      <div className="w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
        <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-blue-400 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5.121 17.804A13.937 13.937 0 0112 15c2.21 0 4.27.534 6.121 1.47M15 10a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
          Information du membre du personnel
        </p>
      </div>
      <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
        <div className="w-3/5">
          <label
            htmlFor="nom"
            className="block text-sm font-medium text-blue-900"
          >
            Nom <span className="text-xl text-red-900">*</span>:
          </label>
          <input
            type="text"
            id="nom"
            name="nom"
            value={formData.nom}
            required
            readOnly
            className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
          />
          {renderError("nom")}
        </div>

        <div className="w-3/5">
          <label
            htmlFor="courriel"
            className="block text-sm font-medium text-blue-900"
          >
            Courriel <span className="text-xl text-red-900">*</span> :
          </label>
          <input
            type="text"
            id="courriel"
            name="courriel"
            value={formData.courriel}
            required
            readOnly
            className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
          />
          {renderError("courriel")}
        </div>
      </div>

      <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
        <div className="w-3/5">
          <label
            htmlFor="poste"
            className="block text-sm font-medium text-blue-900"
          >
            Poste: <span className="text-xl text-red-900">*</span>:
          </label>
          <input
            type="text"
            id="poste"
            name="poste"
            value={formData.poste}
            readOnly={isReadOnly}
            onChange={handleChange}
            className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
          />
          {renderError("poste")}
        </div>
      </div>

      <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
        <div className="w-3/5">
          <label
            htmlFor="Superviseur"
            className="block text-sm font-medium text-blue-900 mb-2"
          >
            Supervision immédiate <span className="text-xl text-red-900">*</span> :
          </label>
          <div className="relative">
            {/* Add the UsersList component with the callback for user selection */}
            {isReadOnly === false && !formData?.managerInfo?.nom && (
              <UsersList
                onUserSelect={(user) => handleUserSelect(user, "managerInfo")}
                initialValue={formData?.managerInfo?.email}
              />
            )}

            {/* Display the selected user's information */}
            {formData?.managerInfo?.nom && (
              <div className="mt-4 p-4 rounded-2xl border border-gray-200 shadow-sm bg-white flex items-center gap-4">
                {/* Avatar */}
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 font-semibold text-lg">
                  {formData.managerInfo.nom.charAt(0).toUpperCase()}
                </div>

                {/* Infos */}
                <div className="flex flex-col">
                  <span className="text-sm font-semibold text-gray-900">
                    {formData.managerInfo.nom}
                  </span>
                  <span className="text-sm text-gray-700">
                    {formData.managerInfo.email}
                  </span>
                </div>

                {/* Bouton supprimer */}
                {!isReadOnly && (
                  <button
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        managerInfo: {
                          nom: "",
                          email: "",
                          userId: "",
                          matricule: "",
                          etatDemande: "",
                        },
                      }))
                    }
                    className="ml-auto text-red-400 hover:text-red-500 transition"
                  >
                    ✕
                  </button>
                )}
              </div>
            )}
          </div>
          {renderError("managerInfo")}
        </div>

        <div className="w-3/5">
          <label
            htmlFor="directionSecteurSurintendance"
            className="block text-sm font-medium text-blue-900 mb-2"
          >
            Direction de service / secteur / surintendance{" "}
            <span className="text-xl text-red-900">*</span> :
          </label>
          <div className="relative">
            {/* Add the UsersList component with the callback for user selection */}
            {isReadOnly === false &&
              !formData?.directionSecteurSurintendance?.nom && (
                <UsersList
                  onUserSelect={(user) =>
                    handleUserSelect(user, "directionSecteurSurintendance")
                  }
                  initialValue={formData?.directionSecteurSurintendance?.email}
                />
              )}

            {/* Display the selected user's information */}
            {formData?.directionSecteurSurintendance?.nom && (
              <div className="mt-4 p-4 rounded-2xl border border-gray-200 shadow-sm bg-white flex items-center gap-4">
                {/* Avatar */}
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 font-semibold text-lg">
                  {formData.directionSecteurSurintendance.nom
                    .charAt(0)
                    .toUpperCase()}
                </div>

                {/* Infos */}
                <div className="flex flex-col">
                  <span className="text-sm font-semibold text-gray-900">
                    {formData.directionSecteurSurintendance.nom}
                  </span>
                  <span className="text-sm text-gray-700">
                    {formData.directionSecteurSurintendance.email}
                  </span>
                </div>

                {/* Bouton supprimer */}
                {!isReadOnly && (
                  <button
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        directionSecteurSurintendance: {
                          nom: "",
                          email: "",
                          userId: "",
                          matricule: "",
                        },
                      }))
                    }
                    className="ml-auto text-red-400 hover:text-red-500 transition"
                  >
                    ✕
                  </button>
                )}
              </div>
            )}
          </div>
          {renderError("directionSecteurSurintendance")}
        </div>
        {/* <div className="w-3/5">
          <label
            htmlFor="directionSecteurSurintendance"
            className="block text-sm font-medium text-blue-900"
          >
            Direction de service / secteur / surintendance:{" "}
            <span className="text-xl text-red-900">*</span>:
          </label>
          <input
            type="text"
            id="directionSecteurSurintendance"
            name="directionSecteurSurintendance"
            value={formData.directionSecteurSurintendance}
            readOnly={isReadOnly}
            onChange={handleChange}
            className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
          />
          {renderError("directionSecteurSurintendance")}
        </div> */}
      </div>

      <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
        <div className="w-3/5 ">
          <label
            htmlFor="dateDebutEntente"
            className="block text-sm font-medium text-blue-900"
          >
            Date de début de l'entente
            <span className="text-xl text-red-900">*</span> :
          </label>
          <ModernDatePicker
            value={formData.dateDebutEntente}
            onChange={(value) =>
              handleChange({ target: { name: "dateDebutEntente", value } })
            }
            disabled={isReadOnly}
            min={new Date().toISOString().split("T")[0]}
            max={getDateDebutEntenteMax()}
            ariaLabel="Choisir la date de début de l'entente"
          />
          {renderError("dateDebutEntente")}
        </div>
        <div className="w-3/5 ">
          <label
            htmlFor="dateFinEntente"
            className="block text-sm font-medium text-blue-900"
          >
            Date de fin de l'entente
            <span className="text-xl text-red-900">*</span> :
          </label>
          <ModernDatePicker
            value={formData.dateFinEntente}
            min={
              formData.dateDebutEntente ||
              new Date().toISOString().split("T")[0]
            }
            max={getDateFinEntenteMax(formData.dateDebutEntente)}
            onChange={(value) =>
              handleChange({ target: { name: "dateFinEntente", value } })
            }
            disabled={isReadOnly || !formData.dateDebutEntente}
            ariaLabel="Choisir la date de fin de l'entente"
          />
          {renderError("dateFinEntente")}
        </div>
      </div>

<div className="mt-10 w-full grid grid-cols-2 gap-0">
        <div className="w-3/5">
          <div className="grid grid-row-2 items-center gap-4">
            <label className="block text-sm font-medium text-blue-900">
              Résidez-vous en Ontario?{" "}
              <span className="text-red-500 ml-1">*</span>
            </label>

            <div className="flex items-center gap-3">
              {["oui", "non"].map((option) => {
                const isSelected = formData.resideOntario === option;

                return (
                  <label
                    key={option}
                    className={`
                  flex items-center justify-center 
                  px-8 py-3 rounded-lg cursor-pointer
                  text-sm font-medium
                  border transition-all duration-200
                  focus-within:ring-2 focus-within:ring-blue-300 focus-within:ring-offset-1
                  ${
                    isSelected
                      ? "bg-blue-100 text-blue-600 border-blue-300"
                      : "bg-white text-gray-500 border-gray-300 hover:border-gray-400 hover:text-gray-600"
                  }
                `}
                  >
                    <input
                      type="radio"
                      name="resideOntario"
                      value={option}
                      checked={isSelected}
                      onChange={handleChange}
                      className="sr-only"
                      disabled={isReadOnly}
                    />
                    {option.charAt(0).toUpperCase() + option.slice(1)}
                  </label>
                );
              })}
            </div>
          </div>

          {renderError("resideOntario")}
          {formData.resideOntario === "non" && (
            <div
              role="alert"
              className="mt-4 rounded-xl border border-red-300 bg-red-50 p-4 text-sm font-medium text-red-800"
            >
              Vous n'êtes pas autorisé à soumettre une demande de télétravail
              hors de l'Ontario. Veuillez communiquer avec votre supervision immédiate.
            </div>
          )}
        </div>
      </div>
    <fieldset
        disabled={formData.resideOntario === "non"}
        className={
          formData.resideOntario === "non"
            ? "pointer-events-none opacity-50"
            : ""
        }
      >
      <div className="w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl mt-10">
        <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-blue-400 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.75 17L8 21h8l-1.75-4M3 13h18M5 3h14a2 2 0 012 2v8H3V5a2 2 0 012-2z"
            />
          </svg>
          Modalités de travail en hybride
        </p>
      </div>

      <div className="mt-10 flex items-start justify-between mb-6">
        <div>
          <h3 className="text-xl font-semibold text-gray-800 tracking-tight">
            La plage horaire de votre travail
          </h3>
          <p className="text-sm text-gray-600 mt-1">
            Veuillez spécifier la plage horaire de votre travail (l'heure de
            début et l'heure de fin, incluant les pauses). L'horaire
            hebdomadaire normal étant de 35 heures par semaine, une journée de
            travail n'excède pas 7 heures.
          </p>
        </div>
      </div>
      <div className="w-3/4 grid grid-cols-2 gap-0">
        <div className="w-3/5 ">
          <label
            htmlFor="heureDebutTravail"
            className="block text-sm font-medium text-blue-900"
          >
            Heure de début <span className="text-xl text-red-900">*</span> :
          </label>
          <select
            id="heureDebutTravail"
            name="heureDebutTravail"
            value={formData.heureDebutTravail}
            onChange={handleChange}
            disabled={isReadOnly}
            className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
          >
            <option value="">Sélectionnez une heure</option>
            <option value="06:00">06:00</option>
            <option value="06:30">06:30</option>
            <option value="07:00">07:00</option>
            <option value="07:30">07:30</option>
            <option value="08:00">08:00</option>
            <option value="08:30">08:30</option>
            <option value="09:00">09:00</option>
          </select>
          {renderError("heureDebutTravail")}
        </div>
        <div className="w-3/5 ">
          <label
            htmlFor="heureFinTravail"
            className="block text-sm font-medium text-blue-900"
          >
            Heure de fin <span className="text-xl text-red-900">*</span> :
          </label>
          <select
            id="heureFinTravail"
            name="heureFinTravail"
            value={formData.heureFinTravail}
            onChange={handleChange}
            disabled={isReadOnly || !formData.heureDebutTravail}
            className="mt-1 w-full p-3 border border-gray-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
          >
            <option value="">Sélectionnez une heure</option>
            {getHeuresFinDisponibles(formData.heureDebutTravail).map(
              (heure) => (
                <option key={heure} value={heure}>
                  {heure}
                </option>
              ),
            )}
          </select>
          {renderError("heureFinTravail")}
        </div>
      </div>

      <div className="mt-10 w-3/4 grid grid-cols-2 gap-0 ">
        <div className="w-3/5">
          <label
            htmlFor="telephoneDomicile"
            className="block text-sm font-medium text-blue-900"
          >
            Numéro de téléphone au domicile :
          </label>
          <input
            type="tel"
            inputMode="numeric"
            id="telephoneDomicile"
            name="telephoneDomicile"
            // value={formData.telephone}
            value={formatPhoneNumber(formData.telephoneDomicile)}
            onChange={handlePhoneNumberChange}
            maxLength={13} // Maximum of 10 digits
            placeholder="123 456 7890"
            readOnly={isReadOnly}
            className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
          />
          {renderError("telephoneDomicile")}
        </div>

        <div className="w-3/5">
          <label
            htmlFor="telephoneCellulaire"
            className="block text-sm font-medium text-blue-900"
          >
            Numéro de téléphone Cellulaire{" "}
            <span className="text-xl text-red-900">*</span>:
          </label>
          <input
            type="tel"
            inputMode="numeric"
            id="telephoneCellulaire"
            name="telephoneCellulaire"
            // value={formData.telephoneCellulaire}
            value={formatPhoneNumber(formData.telephoneCellulaire)}
            maxLength={13}
            onChange={handlePhoneNumberChange}
            placeholder="123 456 7890"
            readOnly={isReadOnly}
            className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
          />
          {renderError("telephoneCellulaire")}
        </div>
      </div>

      <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
        <div className="w-3/5">
          <label
            htmlFor="adresseBureauDomicile"
            className="block text-sm font-medium text-blue-900"
          >
            Adresse du bureau domicile{" "}
            <span className="text-xl text-red-900">*</span>:
          </label>
          <textarea
            id="adresseBureauDomicile"
            name="adresseBureauDomicile"
            value={formData.adresseBureauDomicile}
            readOnly={isReadOnly}
            onChange={handleChange}
            className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
          />
          {renderError("adresseBureauDomicile")}
        </div>
      </div>

      <div className="mt-10 w-full grid grid-cols-2 gap-0">
        <div className="w-full">
          <label
            htmlFor="joursTravailBureau"
            className="block text-sm font-medium text-blue-900"
          >
            Jours de travail au bureau{" "}
            <span className="text-xl text-red-900">*</span>:
          </label>
          <div className="mt-2">
            <p className="text-gray-800">
              <span className="text-sm font-bold text-gray-900">
                Les journées de travail au bureau
              </span>{" "}
              établies au préalable avec votre personne superviseure (veuillez
              cocher les journées de travail au bureau)
            </p>

            <p className=" text-sm leading-relaxed font-semibold text-blue-700">
              *La case "Flexible" est à cocher uniquement pour les membres du
              personnel SIEP ou les membres du personnel itinérant tels que
              définis par les conditions d'emploi
            </p>
          </div>

          <div className="mt-3 grid grid-cols-3 gap-4">
            {joursSemaine.map((jour) => {
              const selected = formData.joursTravailBureau.includes(jour);

              return (
                <label
                  key={jour}
                  className={`
            relative flex items-center gap-3
            px-5 py-3
            rounded-xl
            border-2
            shadow-sm
            transition-all
            duration-200
            cursor-pointer
            select-none
            text-sm
            ${
              selected
                ? "border-blue-600 bg-blue-50 shadow-md"
                : "border-gray-200 bg-white hover:border-blue-300 hover:shadow-md"
            }
            ${isReadOnly ? "opacity-70 cursor-not-allowed" : ""}
          `}
                >
                  <input
                    type="checkbox"
                    value={jour}
                    checked={selected}
                    onChange={handleCheckboxChange}
                    disabled={isReadOnly}
                    className="peer sr-only"
                  />

                  <div
                    className={`
              flex h-6 w-6 items-center justify-center
              rounded-full border-2 transition-all
              ${
                selected
                  ? "border-blue-600 bg-blue-600"
                  : "border-gray-300 bg-white"
              }
            `}
                  >
                    {selected && (
                      <svg
                        className="w-3.5 h-3.5 text-white"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    )}
                  </div>

                  <span
                    className={`font-medium ${
                      selected ? "text-blue-800" : "text-gray-700"
                    }`}
                  >
                    {jour}
                  </span>
                </label>
              );
            })}
          </div>
          {renderError("joursTravailBureau")}
        </div>
      </div>

      <div className="mt-10 w-full grid grid-cols-2 gap-0">
        <div className="w-full">
          <label
            htmlFor="frequenceTravail"
            className="block text-sm font-medium text-blue-900"
          >
            Précisez la fréquence de travail à domicile{" "}
            <span className="text-xl text-red-900">*</span>:
          </label>

          <div className="mt-3 grid grid-cols-4 gap-4">
            {frequences.map((frequence) => {
              const selected = formData.frequenceTravail === frequence;

              return (
                <label
                  key={frequence}
                  className={`
            relative flex items-center gap-3
            px-5 py-3
            rounded-xl
            border-2
            shadow-sm
            transition-all
            duration-200
            cursor-pointer
            select-none
            text-sm
            ${
              selected
                ? "border-blue-600 bg-blue-50 shadow-md"
                : "border-gray-200 bg-white hover:border-blue-300 hover:shadow-md"
            }
            ${isReadOnly ? "opacity-70 cursor-not-allowed" : ""}
          `}
                >
                  <input
                    type="radio"
                    name="frequenceTravail"
                    value={frequence}
                    checked={selected}
                    onChange={handleCheckboxChangeFrequence}
                    disabled={isReadOnly}
                    className="peer sr-only"
                  />

                  <div
                    className={`
              flex h-6 w-6 items-center justify-center
              rounded-full border-2 transition-all
              ${
                selected
                  ? "border-blue-600 bg-blue-600"
                  : "border-gray-300 bg-white"
              }
            `}
                  >
                    {selected && (
                      <svg
                        className="w-3.5 h-3.5 text-white"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    )}
                  </div>

                  <span
                    className={`font-medium ${
                      selected ? "text-blue-800" : "text-gray-700"
                    }`}
                  >
                    {frequence}
                  </span>
                </label>
              );
            })}
          </div>
          {renderError("frequenceTravail")}
        </div>
      </div>

      

      {/* Checkbox */}

      
      <div className="bg-white border border-gray-200 rounded-2xl p-6 mb-8 shadow-sm mt-10">
        {/* Avis légal */}
        <h3 className="text-lg font-semibold text-blue-900 mb-3">
          🔐 Acceptation des modalités
        </h3>

        <p className="text-sm text-gray-600 leading-relaxed mb-3">
          (i) J’ai lu et j'accepte les modalités de la présente entente de
          travail hybride, et du guide de référence portant sur le travail
          hybride du Conseil, ainsi que toute autre politique ou directive
          administrative ayant rapport au personnel du Conseil.
        </p>
        <p className="text-sm text-gray-600 leading-relaxed mb-3">
          (ii) Je confirme que mon bureau à domicile est conforme aux exigences
          précitées.
        </p>
        <p className="text-sm text-gray-600 leading-relaxed mb-3">
          (iii) Je reconnais que le travail hybride est un privilège et non un
          droit et que cette entente de travail hybride peut être révoquée par
          le Conseil en tout temps.
        </p>
        <p className="text-sm text-gray-600 leading-relaxed mb-3">
          (iv) Je reconnais qu’à la fin de cette entente de travail hybride, ou
          si cette entente est résiliée, je serai tenu de retourner au travail
          en présentiel au lieu de travail désigné du Conseil selon mon horaire
          de travail habituel.
        </p>

        {/* Confirmation */}
        <div className="flex items-start gap-3 mt-5">
          <label className="flex items-center cursor-pointer space-x-4 relative">
            <input
              type="checkbox"
              name="acceptationModalites"
              checked={formData.acceptationModalites === "oui"}
              onChange={handleChangeCheckBox}
              className="absolute opacity-0 w-6 h-6"
              disabled={isReadOnly || page === "Mes taches"}
            />
            {/* Custom box */}
            <span
              className="flex items-center justify-center h-6 w-6 rounded-lg border-2 border-gray-300 bg-gray-50 transition-all duration-300 
      checked:border-blue-500 peer-checked:bg-blue-50"
            >
              {/* Check icon */}
              {formData.acceptationModalites === "oui" && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-10 w-10 text-blue-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={3}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              )}
            </span>
            <span className="text-gray-900 font-medium text-sm select-none">
              J'atteste que j'ai lu et compris toutes les modalités du protocole
              d’entente sur le travail hybride à Viamonde.
            </span>
          </label>
        </div>

        {renderError("acceptationModalites")}
      </div>

      <div className="w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl mt-10">
        <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-green-400 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 3l7 3v5c0 5.25-3.438 9.75-7 11-3.562-1.25-7-5.75-7-11V6l7-3zm-2.5 8.5l2 2 4-4"
            />
          </svg>
          Évaluation des risques reliés à la santé et sécurité dans le cadre du
          télétravail
        </p>
      </div>

      <div className="mt-10 w-full grid grid-cols-2 gap-0">
        <div className="w-3/5">
          <div className="grid grid-row-2 items-center gap-4">
            <label className="block text-sm font-medium text-blue-900">
              Est-ce qu’une ou plusieurs des situations suivantes s’appliquent-elles à vous ?{" "}
              <span className="text-xl text-red-900">*</span>
             
            </label>
              <p>• Je suis un nouveau membre du personnel.</p>
              <p>• J’ai déménagé récemment.</p>
              <p>• J’ai changé de lieu de travail à domicile.</p>
            <div className="flex items-center gap-3">
              {["oui", "non"].map((option) => {
                const isSelected = formData.situationApplicable === option;

                return (
                  <label
                    key={option}
                    className={`
                  flex items-center justify-center 
                  px-8 py-3 rounded-lg cursor-pointer
                  text-sm font-medium
                  border transition-all duration-200
                  focus-within:ring-2 focus-within:ring-blue-300 focus-within:ring-offset-1
                  ${
                    isSelected
                      ? "bg-blue-100 text-blue-600 border-blue-300"
                      : "bg-white text-gray-500 border-gray-300 hover:border-gray-400 hover:text-gray-600"
                  }
                `}
                  >
                    <input
                      type="radio"
                      name="situationApplicable"
                      value={option}
                      checked={isSelected}
                      onChange={handleChange}
                      className="sr-only"
                      disabled={isReadOnly}
                    />
                    {option.charAt(0).toUpperCase() + option.slice(1)}
                  </label>
                );
              })}
            </div>
          </div>

          {renderError("situationApplicable")}
        </div>
      </div>

      {formData.situationApplicable === "oui" && (
        <>
      <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
        <div className="w-6/5 ">
          <label
            htmlFor="descriptionLieuTravailDomicile"
            className="block text-sm font-medium text-blue-900"
          >
            Veuillez fournir une brève description du lieu et de l'espace
            (bureau) de votre travail à domicile{" "}
            <span className="text-xl text-red-900">*</span>:
          </label>
          <textarea
            className="mt-2 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            rows="2"
            id="descriptionLieuTravailDomicile"
            name="descriptionLieuTravailDomicile"
            value={formData.descriptionLieuTravailDomicile}
            onChange={handleChange}
            readOnly={isReadOnly}
          />
          {renderError("descriptionLieuTravailDomicile")}
        </div>
      </div>

      <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
        <div className="w-6/5">
          <label
            htmlFor="fileUpload"
            className="block text-sm font-medium text-blue-900 mb-2"
          >
            Téléversez une photo de votre espace de travail{" "}
            <span className="text-xl text-red-900">*</span>{" "}:
          </label>
          <p className="text-sm text-gray-600 leading-relaxed mb-3">
            Cette demande est applicable et obligatoire pour :
          </p>
          <p className="text-sm text-gray-600 leading-relaxed mb-3">
            (i) Les nouveaux membres du personnel.
          </p>
          <p className="text-sm text-gray-600 leading-relaxed mb-3">
            (ii) Les membres du personnel qui ont déménagé.
          </p>
          <p className="text-sm text-gray-600 leading-relaxed mb-3">
            (iii) Les membres du personnel qui ont changé de lieu de travail à
            domicile.
          </p>

          {page !== "Mes taches" && (
            <div className="w-3/5 relative">
              <input
                type="file"
                id="fileUpload"
                name="fileUpload"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={handleFileUpload}
                className="absolute inset-0 opacity-0 cursor-pointer"
                readOnly={isReadOnly}
              />
              <button className="w-full px-4 py-2 border border-blue-500 rounded-lg text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 cursor-pointer">
                Choisir un fichier
              </button>
            </div>
          )}
          {page !== "Mes taches"  && (
            <p className="text-sm text-gray-500 mt-1">
              Formats acceptés : PDF, JPG, JPEG, PNG.
            </p>
          )}
          {renderError("uploadedFile")}
          {fileUploadError && (
            <p style={{ color: "red", marginTop: "0.5rem" }}>
              {fileUploadError}
            </p>
          )}
          {uploadedFile && (
            <div className="w-3/5 mt-3 space-y-2">
              {(() => {
                const filename =
                  uploadedFile.name || uploadedFile.filename || "";
                const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(filename);
                const isPdf = /\.pdf$/i.test(filename);

                return (
                  <div
                    key={uploadedFile._id || filename}
                    className="flex items-center gap-3 border rounded-lg px-3 py-2 bg-white shadow-sm hover:bg-blue-50 transition-colors duration-150"
                  >
                    {/* Icône selon le type */}
                    <span className="text-lg flex-shrink-0">
                      {isImage ? "🖼️" : isPdf ? "📄" : "📎"}
                    </span>

                    {/* Nom + sous-titre cliquable */}
                    <button
                      onClick={() => {
                        setSelectedFile(uploadedFile);
                        setShowPopup(true);
                      }}
                      className="flex-1 min-w-0 text-left group"
                    >
                      <p className="text-sm font-medium text-blue-800 group-hover:text-blue-600 truncate">
                        {filename}
                      </p>
                      <p className="text-xs text-gray-400">
                        Cliquer pour visualiser
                      </p>
                    </button>

                    {/* Flèche d'ouverture */}
                    <span className="text-blue-400 text-xs flex-shrink-0">
                      ↗
                    </span>

                    {/* Bouton supprimer */}
                    {!isReadOnly && (
                      <button
                        onClick={handleFileDelete}
                        className="w-9 h-9 border border-red-500 text-red-600 rounded-lg flex items-center justify-center transition duration-200 hover:bg-red-50 flex-shrink-0"
                      >
                        <TrashIcon className="w-5 h-5" />
                      </button>
                    )}
                  </div>
                );
              })()}
            </div>
          )}
        </div>
      </div>
        </>
      )}

      {showPopup && selectedFile && (
        <FilePreviewModal
          selectedFile={selectedFile}
          fileUrl={fileUrl}
          onClose={() => setShowPopup(false)}
        />
      )}

      <h3 className="mt-10 text-md font-semibold text-blue-900 mb-3">
        Veuillez confirmer les affirmations suivantes:
      </h3>
      <div className="mt-4 w-3/5 space-y-4">
        {questions.map((question, index) => (
          <RadioQuestion
            key={question.name}
            number={index + 1}
            name={question.name}
            label={question.label}
            value={formData[question.name]}
            onChange={handleChange}
            renderError={renderError}
            hasHelp={question.hasHelp}
            info={question.info}
          />
        ))}
      </div>

      {showErgonomieHelp && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/45 px-4 backdrop-blur-sm"
          role="dialog"
          aria-modal="true"
          aria-labelledby="ergonomie-help-title"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) {
              setShowErgonomieHelp(false);
            }
          }}
        >
          <div className="max-h-[90vh] w-full max-w-xl overflow-y-auto rounded-3xl border border-white/60 bg-white shadow-2xl shadow-slate-950/20">
            <div className="flex items-start justify-between gap-4 px-7 pb-4 pt-7">
              <div className="flex items-start gap-3">
                <div className="flex h-11 w-11 flex-none items-center justify-center rounded-2xl bg-gradient-to-br from-blue-600 to-blue-800 text-white shadow-lg shadow-blue-200">
                  <InformationCircleIcon className="h-6 w-6" />
                </div>
                <div>
                  <h2
                    id="ergonomie-help-title"
                    className="text-xl font-bold tracking-tight text-slate-900"
                  >
                    Accéder à la formation sur eBase
                  </h2>
                  <p className="mt-1.5 text-sm leading-5 text-slate-500">
                    Suivez les étapes ci-dessous pour compléter la formation.
                  </p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setShowErgonomieHelp(false)}
                className="flex h-9 w-9 flex-none items-center justify-center rounded-full bg-slate-100 text-xl text-slate-400 transition-colors hover:bg-slate-200 hover:text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                aria-label="Fermer"
              >
                ×
              </button>
            </div>

            <div className="px-7 py-5">
              <ol className="relative space-y-1 before:absolute before:bottom-5 before:left-[15px] before:top-5 before:w-px before:bg-slate-200">
                {[
                  "Ouvrez eBase à l’aide du bouton ci-dessous.",
                  "Saisissez vos identifiants Viamonde.",
                  "Dans la barre latérale gauche, cliquez sur la croix rouge, puis sur « Safe Workplace ».",
                  "Choisissez la formation « Ergonomie et poste de travail ».",
                  "Suivez et complétez la formation.",
                ].map((step, index) => (
                  <li key={step} className="relative flex items-start gap-4 rounded-xl px-1 py-3 transition-colors hover:bg-slate-50">
                    <span className="z-10 flex h-8 w-8 flex-none items-center justify-center rounded-full border-4 border-white bg-blue-100 text-xs font-bold text-blue-700 ring-1 ring-blue-200">
                      {index + 1}
                    </span>
                    <span className="pt-1 text-sm font-medium leading-6 text-slate-700">
                      {step}
                    </span>
                  </li>
                ))}
              </ol>
            </div>

            <div className="mx-7 mb-7 mt-2 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
              <button
                type="button"
                onClick={() => setShowErgonomieHelp(false)}
                className="rounded-xl border border-slate-200 bg-white px-5 py-2.5 text-sm font-semibold text-slate-600 transition-colors hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2"
              >
                Fermer
              </button>
              <a
                href="https://csviamonde.ebasefm.com/safeworkplace/status"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-xl bg-blue-700 px-5 py-2.5 text-center text-sm font-semibold text-white transition-all hover:bg-blue-800 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                Ouvrir eBase
              </a>
            </div>
          </div>
        </div>
      )}

      <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
        <div className="w-6/5 ">
          <label
            htmlFor="risquesEtCommentaires"
            className="block text-sm font-medium text-blue-900"
          >
            Énumérez tout autre risque relevé et/ou ajoutez des commentaires en
            lien avec les questions précédentes du tableau :
          </label>
          <textarea
            className="mt-2 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            rows="2"
            id="risquesEtCommentaires"
            name="risquesEtCommentaires"
            value={formData.risquesEtCommentaires}
            onChange={handleChange}
            readOnly={isReadOnly}
          />
          {renderError("risquesEtCommentaires")}
        </div>
      </div>

      {/* Checkbox */}

      <div className="bg-white border border-gray-200 rounded-2xl p-6 mb-8 shadow-sm mt-10">
        {/* Avis légal */}
        <h3 className="text-lg font-semibold text-blue-900 mb-3">
          🔐 Note importante :
        </h3>

        <p className="text-sm  leading-relaxed mb-3">
          Ce formulaire sera transmis automatiquement par courriel à votre
          personne superviseure pour approbation. Vous recevrez également une
          copie du formulaire.
        </p>
        <p className="text-sm  leading-relaxed mb-3">
          Les parties conviennent que toutes les exigences en matière de santé
          et de sécurité listées ci-dessus ont été respectées par le membre du
          personnel et que des mesures ont été prises concernant les risques
          potentiels ou les autres problèmes de santé et de sécurité éventuels
          relevés.
        </p>
        <p className="text-sm text-gray-600 leading-relaxed mb-3">
          Conformément à l’article 29 (2) de la Loi sur l’accès à l’information
          municipale et la protection de la vie privée, les renseignements
          personnels demandés par l’entremise de ce formulaire permettront au
          membre du personnel et à leur superviseur immédiat d’évaluer les
          risques et de convenir aux exigences en matière de santé et de
          sécurité liées au protocole d’entente sur le travail hybride au
          Conseil scolaire Viamonde. Ces renseignements sont recueillis en vertu
          de la Loi sur l’éducation, L.R.O., 1990, chap. E.2. Pour toute
          question relative à la collecte de ces renseignements, prière de vous
          adresser à la coordonnatrice de l’accès à l’information et la
          protection de la vie privée à demandevieprivée@csviamonde.ca. Pour de
          l’aide avec l’accessibilité, merci d’envoyer votre message à
          accessibilité@csviamonde.ca.
        </p>

        {/* Confirmation */}
        <div className="flex items-start gap-3 mt-5">
          <label className="flex items-center cursor-pointer space-x-4 relative">
            <input
              type="checkbox"
              name="informationsfourniesExactes"
              checked={formData.informationsfourniesExactes === "oui"}
              onChange={handleChangeCheckBox}
              className="absolute opacity-0 w-6 h-6"
              disabled={isReadOnly || page === "Mes taches"}
            />
            {/* Custom box */}
            <span
              className="flex items-center justify-center h-6 w-6 rounded-lg border-2 border-gray-300 bg-gray-50 transition-all duration-300 
      checked:border-blue-500 peer-checked:bg-blue-50"
            >
              {/* Check icon */}
              {formData.informationsfourniesExactes === "oui" && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-10 w-10 text-blue-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={3}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              )}
            </span>
            <span className="text-gray-900 font-medium text-sm select-none">
              Je certifie que toutes les informations fournies dans ce
              formulaire sont exactes et complètes.
            </span>
          </label>
        </div>
        {renderError("informationsfourniesExactes")}
      </div>

      {/* ===== COMMENTAIRE RH (TOUS) ===== */}
      {page === "Mes taches" &&
        formData.etatDemande === "En traitement" &&
        selectedForm?.traitant[selectedForm.traitant.length - 1]?.userId ===
          user?.id && (
          <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
            <div className="w-full mt-4">
              <label
                htmlFor="commentaireRh"
                className="block text-sm font-medium text-blue-900"
              >
                Commentaire:
              </label>
              <textarea
                placeholder="Ajoutez une qualification..."
                className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
                rows="5"
                id="commentaire"
                name="commentaire"
                value={commentaire}
                onChange={(e) => setCommentaire(e.target.value)}
              />
              {renderError("commentaireRH")}
            </div>
          </div>
        )}

      {/* Privacy Statement */}

      <div className="flex justify-start mt-16">
        {/* Left-aligned Buttons */}
        <div className="flex gap-4">
          {(formData.etatDemande === "Brouillon" ||
            formData.etatDemande === "") && (
            <button
              type="button"
              onClick={handleSave}
              className="
          flex items-center justify-center
          px-5 py-2.5 rounded-xl text-sm font-medium
          bg-gray-700 text-white
          hover:bg-gray-600 active:scale-95
          transition-all duration-200 shadow-sm hover:shadow-md w-24
        "
            >
              Enregistrer
            </button>
          )}

          {(formData?.etatDemande === "Brouillon" ||
            formData?.etatDemande === "" ||
            (formData?.etatDemande === "Rejeté" && page !== "Mes taches")) && (
            <button
              type="button"
              onClick={handleSubmit}
              className="
          flex items-center justify-center
          px-5 py-2.5 rounded-xl text-sm font-medium
          bg-green-600 text-white
          hover:bg-green-500 active:scale-95
          transition-all duration-200 shadow-sm hover:shadow-md w-24
        "
            >
              Soumettre
            </button>
          )}
          {page === "Mes taches" &&
            selectedForm?.etatDemande !== "Rejeté" &&
            selectedForm?.etatDemande !== "Soumis" &&
            selectedForm?.etatDemande !== "Approuvé" &&
             (
              <button
                type="button"
                className="
            flex items-center justify-center
            px-5 py-2.5 rounded-xl text-sm font-medium
            bg-red-600 text-white
            hover:bg-red-500 active:scale-95
            transition-all duration-200 shadow-sm hover:shadow-md w-24
          "
                onClick={handleRejeter}
              >
                Rejeter
              </button>
            )}
          {page === "Mes taches" &&
            selectedForm?.etatDemande !== "Rejeté" &&
            selectedForm?.etatDemande !== "Soumis" &&
            selectedForm?.etatDemande !== "Approuvé" &&
             (
              <button
                type="button"
                className="
            flex items-center justify-center
            px-5 py-2.5 rounded-xl text-sm font-medium
            bg-green-600 text-white
            hover:bg-green-500 active:scale-95
            transition-all duration-200 shadow-sm hover:shadow-md w-24
          "
                onClick={handleApprouve}
              >
                Approuver
              </button>
            )}
        </div>
      </div>
      </fieldset>

      {isLoading && (
        <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-90 z-50">
          <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
          <p className="ml-3 text-gray-700 font-medium">
            Chargement en cours...
          </p>
        </div>
      )}

      {/* </>)} */}
      {isSubmitted && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
          <div
            className={`flex items-center space-x-3 px-5 py-4 bg-white ${couleur} rounded-lg shadow-xl transform transition-all duration-500 ease-in-out animate-bounce`}
          >
            <CheckCircleIcon className={`h-8 w-8 ${couleur} animate-pulse`} />
            <span className="text-lg font-semibold">{message}</span>
          </div>
        </div>
      )}
      {showAccessDenied && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50">
          <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl p-8 w-[380px] text-center border border-white/30 animate-fadeIn">
            {/* Icon */}
            <div className="flex justify-center mb-5">
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-red-100 shadow-inner">
                <span className="text-3xl">⛔</span>
              </div>
            </div>

            {/* Title */}
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Accès refusé
            </h2>

            {/* Message principal */}
            <p className="text-gray-700 mb-2">
              Vous n'êtes pas autorisé à consulter ce formulaire.
            </p>

            {/* Sous message */}
            <p className="text-sm text-gray-500 mb-6">
              Redirection vers la page des réclamations de dépenses...
            </p>

            {/* Loader */}
            <div className="flex justify-center mb-6">
              <div className="w-6 h-6 border-4 border-gray-200 border-t-red-500 rounded-full animate-spin"></div>
            </div>

            {/* Button */}
            <button
              onClick={() => {
                navigate("/EntenteTravailHybrid");
                setShowAccessDenied(false);
              }}
              className="px-5 py-2.5 bg-red-600 text-white rounded-xl hover:bg-red-500 transition-all duration-200 shadow-md hover:shadow-lg"
            >
              Retour
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EntenteTravailHybrid;
